import React, { useRef } from "react";

const PasswordWrapper = ({ children }) => {
    const passwordRef = useRef();

    const togglePassword = () => {
        const iconClasses = ["fa-eye-slash", "fa-eye"];
        const refChildren = passwordRef.current.children;
        const isInputTypeText = refChildren[0].type === "text";

        //refChildren[0] -- represents the input tag
        refChildren[0].type = isInputTypeText ? "password" : "text";

        //refChildren[1] -- represent the eye icon
        refChildren[1].classList.replace(
            iconClasses[isInputTypeText ? 0 : 1],
            iconClasses[isInputTypeText ? 1 : 0]
        );
    };
    return (
        <>
            <div className="flex" ref={passwordRef || null}>
                {children}
                <i
                    className={
                        "fas fa-eye fa-xs -ml-6 mt-auto mb-auto cursor-pointer"
                    }
                    onClick={togglePassword}
                ></i>
            </div>
        </>
    );
};

export default PasswordWrapper;
